module.exports = __webpack_public_path__ + "img/wifi000001.3dc65be4.jpg";